import { React, useState, useEffect } from "react";
import "./LocationComponent.css";
import pin from "./assets/pin.jpg";

function LocationComponent() {
  const locationName = "Manchester, UK";
  const mapboxAccessToken =
    "sk.eyJ1IjoiZXZleWxpY2lvdXMiLCJhIjoiY203MHpqNTR6MDg0NDJpc2FsNmZncDhvYSJ9.bKF2lYjXHQMFafu9-kyGKg";
  const avatarUrl = "./EVEY LOGO.png";

  const [mapUrl, setMapUrl] = useState("");

  useEffect(() => {
    const mapWidth = 300;
    const mapHeight = 200;

    const handleResize = () => {
      const isMobile = window.innerWidth <= 875;

      if (isMobile) {
        setMapUrl(
          `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/-2.244418348,53.47814006393,11.2,0,0/${mapWidth}x${mapHeight}@2x?access_token=${mapboxAccessToken}`
        );
      } else {
        setMapUrl(
          `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/-2.245118348,53.47293393,11.3,0,0/${mapWidth}x${mapHeight}@2x?access_token=${mapboxAccessToken}`
        );
      }
    };

    // Set initial URL
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, [mapboxAccessToken]);

  return (
    <div className="location-container">
      <div className="map-container">
        <div className="map-image-wrapper">
          <img src={mapUrl} alt="Location Map" className="map-image" />
          <div className="location-overlay">
            <img src={pin} alt="Pin" className="pin-img" />
            {locationName}
          </div>
        </div>
        <div className="avatar-ping">
          <img src={avatarUrl} alt="Avatar" className="avatar-overlay" />
        </div>
      </div>
    </div>
  );
}

export default LocationComponent;
